module.exports = __webpack_public_path__ + "assets/img/24-l.ed9e4da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/24-l.jpg
// module id = /q2J
// module chunks = 0